import { TextField } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput, FIELD_TYPES, DynamicTableProperties } from 'src/api/process-module';

interface DynamicTableFieldProps {
  field: FieldInput & Partial<Field>;
  index: number;
  handleFieldChange: (index: number, field: Partial<FieldInput & Partial<Field>>) => void;
  isSubmitting: boolean;
  isUsingExistingField: boolean;
}

export const DynamicTableField = ({
  field,
  index,
  handleFieldChange,
  isSubmitting,
  isUsingExistingField,
}: DynamicTableFieldProps) => {
  const properties = field.properties as DynamicTableProperties;

  return (
    <>
      <TextField
        fullWidth
        label="Table Configuration"
        value={properties?.tableConfig || ''}
        onChange={(e) =>
          handleFieldChange(index, {
            properties: {
              ...properties,
              type: FIELD_TYPES.DYNAMIC_TABLE,
              tableConfig: e.target.value,
            } as DynamicTableProperties,
          })
        }
        disabled={isSubmitting || isUsingExistingField}
        helperText="Enter dynamic table configuration in JSON format"
      />
    </>
  );
};
